// src/config/index.js
const config = {
    // 开发环境
    development: {
        apiBaseUrl: 'http://127.0.0.1:8081/gxnnk',
        // 其他配置...
        appName: 'JeecgBoot App',
        version: '1.0.0'
    },

    // 生产环境
    production: {
        apiBaseUrl: 'http://121.41.170.72:3004/jeecg-boot',
        appName: 'JeecgBoot App',
        version: '1.0.0'
    }
}

// 根据当前环境导出配置
const env = process.env.NODE_ENV || 'development'
export default config[env]
